import { Component, Input } from "@angular/core";
import { Subject } from "rxjs";
import { WindowService } from "src/shared/providers/window.service";

@Component({
    templateUrl: 'confirm-remove-employee.html',
    standalone: false
})
export class RemoveEmployeeComponent {
  boundCancel = this.cancel.bind(this);
  boundConfirm = this.confirm.bind(this);

  @Input() confirmSubject: Subject<boolean>;
  @Input() employeeName?: string;

  constructor(public windowService: WindowService) {}

  confirm() {
    this.confirmSubject.next(true);
  }

  cancel() {
    this.confirmSubject.next(false);
  }
}
